import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';

import {
  ContactItem,
  NextButton,
  LoadingIcon,
  LoadMoreContainer,
  LoadMore,
  ContactListContainer,
  HeaderTitle,
  HeaderSubtitle,
} from './styles';
import arrowRight from '~/assets/images/ic_arrow.svg';
import { getPhones, sendToken } from './Steps-requests';

function SelectPhone(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState(1);
  const [phones, setPhones] = useState([]);

  const access_token = useSelector(state => state.accessReducer.access_token);
  const location = useSelector(state => state.accessReducer.location);
  const phonesList = useSelector(state => state.accessReducer.phonesList);

  useEffect(() => {
    setPhones(phonesList);
  }, []);

  return (
    <div className="pb-3">
      <HeaderTitle>
        Selecione um celular para envio do código de validação.
      </HeaderTitle>
      <HeaderSubtitle>Encontramos os seguintes:</HeaderSubtitle>
      <ContactListContainer>
        <ContactItem className="mb-3" onClick={() => setSelectedContact(1)}>
          <input
            type="radio"
            value="option1"
            style={{ marginRight: 10 }}
            checked={selectedContact === 1 ? true : false}
          />
          <span>Nenhuma das opções</span>
        </ContactItem>
        {phones.map(item => {
          return (
            <ContactItem
              id={item.contactId}
              key={item.contactId}
              className="mb-3"
              onClick={() => setSelectedContact(item.contactId)}
            >
              <input
                type="radio"
                value="option1"
                style={{ marginRight: 10 }}
                checked={item.contactId === selectedContact ? true : false}
              />
              <span>{item.contact}</span>
            </ContactItem>
          );
        })}
        {phones.length >= 10 ? (
          <LoadMoreContainer>
            <LoadMore>Carregar mais...</LoadMore>
          </LoadMoreContainer>
        ) : null}
      </ContactListContainer>

      <NextButton
        onClick={() => {
          if (selectedContact === 1) {
            dispatch({ type: 'STEP', step: 7 });
          } else {
            setLoading(true);
            let selectedPhone = '';
            let phoneIndex = '';
            phones.map((phone, index) => {
              if (phone.contactId === selectedContact) {
                selectedPhone = phone.contact;
                phoneIndex = index;
              }
            });
            sendToken(
              {
                tokenType: 'ADD_CONTACT',
                contactId: phones[phoneIndex].contactId,
              },
              location,
              access_token,
            )
              .then(res => {
                toast.success(
                  `Um código de SMS foi enviado para o telefone: ${selectedPhone}`,
                );
                dispatch({ type: 'STEP', step: 5 });
                dispatch({
                  type: 'ADD_CONTACT',
                  email: '',
                  contactId: selectedPhone,
                });
                setLoading(false);
              })
              .catch(err => {
                toast.error(err.response.data.message);
                setLoading(false);
              });
          }
        }}
        disabled={loading}
      >
        {loading ? (
          <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
        ) : (
         <span>Avançar</span>
        )}
      </NextButton>
    </div>
  );
}

export default SelectPhone;


